import { gsap } from './app/gsap';
import { ScrollTrigger } from './app/scrollTrigger';
import { ScrollSmoother } from './app/ScrollSmoother.js';
import { ScrollToPlugin } from './app/ScrollToPlugin.js';
gsap.registerPlugin(ScrollTrigger, ScrollSmoother, ScrollToPlugin);

import Splitting from 'splitting';

gsap.registerPlugin(ScrollTrigger);
const header = document.querySelector('.site-header');

const scroller = ScrollSmoother.create({
	smooth: 1,
	effects: true,
	smoothTouch: 0.3,
});

// Pin the Late Night sub-nav below the fixed header
if (document.body.classList.contains('page-template-page-nocturne')) {
	const stickyNav = document.querySelector('.position-sticky');
	if (stickyNav) {
		ScrollTrigger.create({
			trigger: stickyNav,
			start:
				'top top+=' + ((header ? header.offsetHeight : 0) + 10) + 'px',
			endTrigger: 'footer',
			end: 'bottom top',
			pin: true,
			pinSpacing: false,
			onToggle: function (self) {
				if (self.isActive) {
					stickyNav.classList.add('is-pinned');
				} else {
					stickyNav.classList.remove('is-pinned');
				}
			},
		});
	}
}

window.addEventListener('load', () => {
	ScrollTrigger.refresh();
});

document.querySelectorAll('.site-masquerade-letter').forEach((_sel) => {
	const openLetter = _sel.querySelector(
		'.site-masquerade-letter__letter-opened'
	);
	const letterWords = openLetter.querySelector('.site-poto-letter');

	Splitting({ target: letterWords, by: 'words' });
	const words = letterWords.querySelectorAll('.word');

	gsap.set(words, {
		opacity: 0,
		xPercent: () => gsap.utils.random(-100, 100),
		yPercent: () => gsap.utils.random(-10, 10),
		z: () => gsap.utils.random(500, 950),
		rotationX: () => gsap.utils.random(-90, 90),
		willChange: 'opacity, transform',
	});

	gsap.set(openLetter, {
		scale: 0.4,
		y: 0,
		opacity: 0,
		visibility: 'hidden',
		filter: 'blur(8px)',
	});

	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: _sel,
			start: 'top 75%',
			end: 'top 100px',
			scrub: true,
		},
	});

	tl.to(openLetter, {
		scale: 1,
		y: 0,
		opacity: 1,
		filter: 'blur(0px)',
		visibility: 'visible',
		duration: 1,
		ease: 'power3.out',
	}).to(
		words,
		{
			opacity: 1,
			xPercent: 0,
			yPercent: 0,
			z: 0,
			rotationX: 0,
			rotationY: 0,
			ease: 'expo.out',
			stagger: {
				each: 0.08,
				from: 'random',
			},
			duration: 1.2,
		},
		'<0.4'
	);
});

if (header) {
	// ScrollTrigger.create({
	// 	trigger: '.home h2.site-title-effect',
	// 	start: 'bottom bottom',
	// 	end: 'bottom top',
	// 	onEnter: () => {
	// 		document.body.classList.add('fixed-header');
	// 	},
	// 	onLeaveBack: () => {
	// 		document.body.classList.remove('fixed-header');
	// 	}
	// });
}

if (
	document.body.classList.contains('home') &&
	document.querySelector('.site-header')
) {
	// gsap.set(document.querySelector('.site-header'), {
	// 	opacity: 0,
	// 	y: -20,
	// 	willChange: 'opacity, transform'
	// });

	//  ScrollTrigger.create({
	//  	trigger: '#phantom-intro-video',
	//  	start: 100,
	//  	end: 'top top',
	// 	onEnter: () => {
	// 		gsap.to(document.querySelector('.site-header'), {
	// 			opacity: 1,
	// 			y: 0,
	// 			duration: 1.2,
	// 			ease: 'power3.out'
	// 		});
	// 	},
	// 	onLeaveBack: () => {
	// 		gsap.to(document.querySelector('.site-header'), {
	// 			opacity: 0,
	// 			y: -20,
	// 			duration: 0.6,
	// 			ease: 'power3.in'
	// 		});
	// 	}
	// });

	const navHeader = document.querySelector('header.site-header');
	const vignette = document.querySelector('.vignette');
	const body = document.body;

	const showHideNav = () => {
		const y = window.pageYOffset;
		const isMobile = window.innerWidth <= 980;

		// Thresholds
		const headerScrolledThreshold = isMobile ? 850 : 850;
		const vignetteThreshold = 850;
		const mobileBodyScrolledThreshold = 1;

		// Body scroll state (earlier trigger for mobile only)
		if (isMobile && y > mobileBodyScrolledThreshold) {
			body.classList.add('has-scrolled');
		} else if (y <= mobileBodyScrolledThreshold) {
			body.classList.remove('has-scrolled');
		}

		// Header + vignette logic
		if (y > headerScrolledThreshold) {
			navHeader.classList.add('is-scrolled');
			vignette.classList.add('is-header-scrolled');
		} else if (y > 100) {
			navHeader.classList.add('is-scrolling');
			navHeader.classList.remove('is-scrolled');

			if (y > vignetteThreshold) {
				vignette.classList.add('is-header-scrolled');
			} else {
				vignette.classList.remove('is-header-scrolled');
			}
		} else {
			navHeader.classList.remove('is-scrolling', 'is-scrolled');
			vignette.classList.remove('is-header-scrolled');
			body.classList.remove('has-scrolled');
		}
	};

	window.addEventListener('resize', () => {
		showHideNav();
	});
	window.addEventListener('scroll', () => {
		showHideNav();
	});
}

document.querySelectorAll('.site-text-fade').forEach((el) => {
	Splitting({ target: el, by: 'words' });

	const words = el.querySelectorAll('.word');

	gsap.fromTo(
		words,
		{
			opacity: 0,
			willChange: 'opacity',
		},
		{
			opacity: 1,
			stagger: 0.005,
			ease: 'none',
			scrollTrigger: {
				trigger: el,
				start: 'top 90%',
				end: 'top 40%',
				scrub: true,
			},
		}
	);
});

document.querySelectorAll('.site-title-effect').forEach((el) => {
	Splitting({ target: el, by: 'chars' });
	const chars = el.querySelectorAll('.char');
	const totalChars = chars.length;

	chars.forEach((char, index) => {
		gsap.set(char.parentNode, {
			perspective: 1000,
		});

		gsap.fromTo(
			char,
			{
				'will-change': 'transform',
				x: () => {
					const mid = Math.ceil(totalChars / 2);
					const offset =
						index < mid
							? index
							: mid -
							  Math.abs(Math.floor(totalChars / 2) - index) -
							  1;
					return (
						200 *
						(totalChars % 2
							? Math.abs(mid - 1 - offset)
							: Math.abs(mid - offset)) *
						(index < totalChars / 2 ? -1 : 1)
					);
				},
				y: () => {
					const mid = Math.ceil(totalChars / 2);
					const offset =
						index < mid
							? index
							: mid -
							  Math.abs(Math.floor(totalChars / 2) - index) -
							  1;
					return 60 * offset;
				},
				rotationY: -270,
				rotationZ: () => {
					const mid = Math.ceil(totalChars / 2);
					const offset =
						index < mid
							? index
							: mid -
							  Math.abs(Math.floor(totalChars / 2) - index) -
							  1;
					return index < totalChars / 2
						? 8 * Math.abs((offset - totalChars) / 2)
						: -8 * Math.abs((offset - totalChars) / 2);
				},
			},
			{
				x: 0,
				y: 0,
				rotationY: 0,
				rotationZ: 0,
				scale: 1,
				ease: 'power2.inOut',
				immediateRender: false,
				scrollTrigger: {
					trigger: el,
					start: 'top bottom+=40%',
					end: 'top top+=15%',
					scrub: true,
					onLeave: () =>
						document.body.classList.add('video-complete'),
					onEnterBack: () =>
						document.body.classList.remove('video-complete'),
				},
			}
		);
	});
});

document.querySelectorAll('.site-title-secondary-effect').forEach((el) => {
	Splitting({ target: el, by: 'chars' });
	const chars = el.querySelectorAll('.char');
	gsap.fromTo(
		chars,
		{
			willChange: 'transform',
			transformOrigin: '50% 100%',
			scaleY: 0,
		},
		{
			ease: 'power3.in',
			opacity: 1,
			scaleY: 1,
			stagger: 0.05,
			scrollTrigger: {
				trigger: el,
				start: 'top top',
				end: 'bottom bottom',
				scrub: true,
				toggleActions: 'play none none none',
				once: true,
			},
		}
	);
});

window.addEventListener('resize', () => {
	ScrollTrigger.refresh(true);
});

// document.querySelectorAll('.phantom-handwriting').forEach((section) => {
// 	const figures = section.querySelectorAll('figure.wp-block-image img');

// 	if (!figures.length) {
// 		return;
// 	}

// 	gsap.set(figures, { opacity: 0, willChange: 'opacity' });

// 	gsap.to(figures, {
// 		opacity: 1,
// 		stagger: 0.8,
// 		duration: 0.5,
// 		ease: 'power2.out',
// 		scrollTrigger: {
// 			trigger: section,
// 			start: 'top 80%',
// 			end: 'bottom 60%',
// 			toggleActions: 'play none none none',
// 			markers: false,
// 		},
// 	});
// });

window.addEventListener('load', () => {
	setTimeout(() => {
		document.querySelectorAll('.fade-title').forEach((_title) => {
			_title.style.opacity = 1;
			Splitting({ target: _title, by: 'chars' });

			const letters = _title.querySelectorAll('.char');

			gsap.to(letters, {
				opacity: 1,
				transform: 'rotate(0deg)',
				willChange: 'opacity, transform',
				duration: 0.8,
				stagger: 0.1,
				ease: 'power3.out',
			});
		});
	}, 1000);

	document.body.classList.add('loaded');

	requestAnimationFrame(() => {
		document
			.querySelectorAll('.site-title-secondary-effect, .site-text-fade')
			.forEach((el) => {
				const bounds = el.getBoundingClientRect();
				const inView =
					bounds.top < window.innerHeight && bounds.bottom > 0;

				if (inView) {
					ScrollTrigger.getAll().forEach((trigger) => {
						if (
							trigger.trigger === el ||
							el.contains(trigger.trigger)
						) {
							if (trigger.animation) {
								trigger.animation.play();
							}
						}
					});
				}
			});
	});
	ScrollTrigger.refresh();
});

// document.querySelectorAll('.gradient-canvas').forEach(canvas => {

// 	const context = canvas.getContext('2d');
// 	let time = 0;

// 	const color = function(x, y, r, g, b) {
// 		context.fillStyle = `rgb(${ r }, ${ g }, ${ b })`;
// 		context.fillRect(x, y, 10, 10);
// 	};
// 	const R = function(x, y, time) {
// 		return (Math.floor(192 + 64 * Math.cos((x * x - y * y) / 300 + time)));
// 	};

// 	const G = function(x, y, time) {
// 		return (Math.floor(192 + 64 * Math.sin((x * x * Math.cos(time / 4) + y * y * Math.sin(time / 3)) / 300)));
// 	};

// 	const B = function(x, y, time) {
// 		return (Math.floor(192 + 64 * Math.sin(5 * Math.sin(time / 9) + ((x - 100) * (x - 100) + (y - 100) * (y - 100)) / 1100)));
// 	};

// 	const startAnimation = function() {
// 		for (x = 0; x <= 30; x ++) {
// 			for (y = 0; y <= 30; y ++) {
// 				color(x, y, R(x, y, time), G(x, y, time), B(x, y, time));
// 			}
// 		}
// 		time = time + 0.03;
// 		window.requestAnimationFrame(startAnimation);
// 	};

// 	startAnimation();

// })

// document.querySelectorAll('.slide-video').forEach((_v) => {
// 	const canvas = _v.querySelector('canvas');
// 	gsap.fromTo(canvas,
// 		{
// 			top: 0
// 		},
// 		{
// 			ease: 'none',
// 			 scrollTrigger: {
// 				pin: true,
// 			 	trigger: _v,
// 			 	start: 'top top',
// 			 	end: 'bottom top',
// 			 	scrub: true,
// 				 pinSpacing: false,
// 				 opacity: 0
// 			}
// 		}
// 	);
// });

// if (!document.body.classList.contains('home')) {
// 	document.body.classList.add('video-complete');
// }

const continueButton = document.querySelector('.continue-down-arrow');
if (continueButton) {
	continueButton.addEventListener('click', (e) => {
		const id = e.target.getAttribute('href');
		// console.log(id);
		// scroller.scrollTo(id, true, "top top");
		e.preventDefault();
	});
}

document.querySelectorAll('a[href*="#"]:not([href="#"])').forEach((anchor) => {
	anchor.addEventListener('click', function (e) {
		const href = this.getAttribute('href');
		const [url, hash] = href.split('#');
		if (!hash) {
			return;
		}

		const isSamePage =
			!url ||
			url === window.location.href.split('#')[0] ||
			url === window.location.pathname;

		if (isSamePage) {
			const target = document.getElementById(hash);
			if (target) {
				e.preventDefault();
				scroller.scrollTo(target, true, 'top top');
			}

			// 📱 Always close mobile nav if on mobile
			if (window.innerWidth <= 768) {
				closeMobileMenu();
			}
		}
	});
});

window.addEventListener('load', () => {
	const hash = window.location.hash;
	if (hash) {
		const target = document.querySelector(hash);
		if (target) {
			scroller.scrollTo(target, true, 'top top');
		}
	}
});

function closeMobileMenu() {
	const nav = document.querySelector('.site-navigation');
	if (nav) {
		nav.classList.remove('site-navigation__nav--active');
		nav.classList.remove('site-navigation--active');
	}

	const toggle = document.querySelector('.site-navigation__navicon');
	if (toggle) {
		toggle.classList.remove('is-active');
		toggle.setAttribute('aria-expanded', 'false');
	}
}

document.querySelectorAll('img[src$=".svg"]').forEach((img) => {
	fetch(img.src)
		.then((res) => res.text())
		.then((svgText) => {
			const parser = new DOMParser();
			const doc = parser.parseFromString(svgText, 'image/svg+xml');
			const svg = doc.querySelector('svg');

			// Replace the <img> with inline SVG
			img.replaceWith(svg);

			// Now get paths from it
			const paths = svg.querySelectorAll('path');
		})
		.catch(console.error);
});

window.addEventListener('load', () => {
	if (!document.body.classList.contains('home')) return;

	const buttonWrapper = document.querySelector('.site-book-now-button');
	const svg = document.querySelector('figure.desktop-hidden > svg');
	if (!buttonWrapper || !svg) return;

	const setSvgWidth = () => {
		const viewport = window.innerWidth;

		if (viewport < 980) {
			// Measure wrapper width (fixed at 100% of viewport)
			const wrapperWidth =
				buttonWrapper.getBoundingClientRect().width || viewport;

			svg.style.width = `${wrapperWidth}px`;
			svg.style.maxWidth = 'none';
		} else {
			svg.style.width = '';
			svg.style.maxWidth = '';
		}
	};

	// Observe wrapper width instead of button
	const resizeObserver = new ResizeObserver(setSvgWidth);
	resizeObserver.observe(buttonWrapper);

	window.addEventListener('resize', setSvgWidth);
	setSvgWidth();
});

const onReady = (fn) => {
	if (document.readyState !== 'loading') fn();
	else document.addEventListener('DOMContentLoaded', fn);
};

onReady(() => {
	const desktopVideo = document.getElementById('masthead-desktop');
	const mobileVideo = document.getElementById('masthead-mobile');

	if (!desktopVideo && !mobileVideo) return;

	const breakpoint = window.matchMedia('(min-width: 980px)');

	// POSTER ELEMENTS
	const desktopPoster = document.querySelector(
		'.site-masthead__poster.mobile-hidden'
	);
	const mobilePoster = document.querySelector(
		'.site-masthead__poster.desktop-hidden'
	);

	// iOS autoplay helper
	const tryPlay = (video) => {
		video.play().catch(() => {
			setTimeout(() => video.play().catch(() => {}), 120);
		});
	};

	// Load video sources dynamically
	const loadSources = (videoEl) => {
		if (!videoEl) return;

		const mp4 = videoEl.dataset.mp4;
		const webm = videoEl.dataset.webm;

		let html = '';
		if (mp4) html += `<source src="${mp4}" type="video/mp4">`;
		if (webm) html += `<source src="${webm}" type="video/webm">`;

		videoEl.innerHTML = html;
		videoEl.load();

		// HIDE THE CORRECT POSTER WHEN VIDEO IS READY
		videoEl.addEventListener(
			'loadeddata',
			() => {
				if (videoEl.id === 'masthead-desktop') {
					if (desktopPoster) desktopPoster.style.display = 'none';
				} else {
					if (mobilePoster) mobilePoster.style.display = 'none';
				}
			},
			{ once: true }
		);

		tryPlay(videoEl);
	};

	// Remove all sources and reset poster visibility
	const unloadVideo = (videoEl) => {
		if (!videoEl) return;
		videoEl.pause();
		videoEl.innerHTML = '';
		videoEl.load();

		// Restore poster visibility since this video is now inactive
		if (videoEl.id === 'masthead-desktop') {
			if (desktopPoster) desktopPoster.style.display = '';
		} else {
			if (mobilePoster) mobilePoster.style.display = '';
		}
	};

	// INITIAL LOAD — no timeout!
	const init = () => {
		if (breakpoint.matches) {
			loadSources(desktopVideo);
			unloadVideo(mobileVideo);
		} else {
			loadSources(mobileVideo);
			unloadVideo(desktopVideo);
		}
	};

	init();

	// UPDATE ON BREAKPOINT CHANGE
	breakpoint.addEventListener('change', (e) => {
		if (e.matches) {
			loadSources(desktopVideo);
			unloadVideo(mobileVideo);
		} else {
			loadSources(mobileVideo);
			unloadVideo(desktopVideo);
		}
	});
});
